declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { DBOperation } from '../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveProviderServiceChargeRequest, GetIVFAdditionalDetailsRequest, GenericProcPostRequest, S_Methods, GenericParams, FTV, IvfExtraDataController, SaveIvfAdditionalDataRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';

@Component({
  selector: 'ngbivfadditionaldetailedit',
  templateUrl: './ivfadditionaldetailedit.modal.html',
  styleUrls: ['./ivfadditionaldetailedit.modal.scss']
})

export class NgbIvfAdditionalDetailEditModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  @Input() CycleCode: number;
  @Input() Title: string;
  @Input() Context: string;
  @Input() Notes: string;
  @Input() CurrentNotes: IvfExtraDataController;
  public UpdatedNotes: string;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {
    this.UpdatedNotes = this.CurrentNotes.DataValue;
  }
  EditNotes() {
    var saveReq = new SaveIvfAdditionalDataRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40380;
    var getReq: GenericParams = new GenericParams();
    getReq.Params = [
      new FTV(this.CurrentNotes.DataContext, this.CurrentNotes.DataType, this.UpdatedNotes)
    ];
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.FacilityCode = AppData.Instance().SelectedBranchCode;
    saveReq.TreatmentCycle = this.CycleCode;
    saveReq.QueryData = JSON.stringify(getReq);
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40380;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  //EditNotes() {
  //  var saveReq = new GetIVFAdditionalDetailsRequest();
  //  var gReq: GenericProcPostRequest = new GenericProcPostRequest();
  //  saveReq.ConditionalOperator = 40460;
  //  saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
  //  saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
  //  saveReq.CycleCode = this.CycleCode;
  //  saveReq.Title = this.Title;
  //  saveReq.Context = this.Context;
  //  saveReq.Notes = this.UpdatedNotes;
  //  saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  var str = JSON.stringify(saveReq);
  //  gReq.ConditionalOperator = 40460;
  //  gReq.QueryData = str;
  //  gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.actorservice.Save<GenericProcPostRequest>(
  //    gReq, S_Methods.SaveGenericPost)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        if (this.ApiResData.Result[0].length > 0) {
  //          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
  //          this.stopRefreshing();
  //          this.activeModal.close();
  //        }
  //        else {
  //          alertFunctions.AlertParam("Invalid Operation...!");
  //          this.stopRefreshing();
  //        }
  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {
  //          alert(this.ApiResData.ErrorData);
  //        }
  //        else {
  //          this.stopRefreshing();
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //        }
  //      }

  //    },
  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);

  //          this.stopRefreshing();
  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);

  //          this.stopRefreshing();
  //        }
  //      }
  //    );
  //}

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
